import ar from './ar.json';
import en from './en.json';

/**
 * The Moderation module's catalogue, registered from `app.config.tsx` under the
 * `moderation` namespace — `shared/i18n` never imports a module (W2).
 */
export const moderationCatalogs = { ar, en };
